





































































































































import PaperPlanIcon from '@/app/ui/assets/paper_plane_icon.vue'
import ListIcon from '@/app/ui/assets/list_icon.vue'
import dayjs from 'dayjs'
import { Component, Prop, Vue } from 'vue-property-decorator'
import dayjsDuration from 'dayjs/plugin/duration'
import { Utils } from '@/app/infrastructures/misc'
import Button from '@/app/ui/components/Button/index.vue'
import PriorityIcon from '@/app/ui/assets/ics_f_priority-fast.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import PickupController from '@/app/ui/controllers/PickupController'

interface Pickup {
  bookingId: string
  doOriginPackageId: string
  flag: string
  shipmentId: string
  groupId: string
  productType: string
  isOnepack: boolean
  pickup: {
    fullname: string
    phoneNumber: string
    latitude: number
    longitude: number
    address: string
  }
  courierPickupDetail: {
    courierId: string
    courierName: string
    courierTypeValid: string
    phoneNumber: string
    partnerName: string
  }
  createdAt: string
  history: {
    reason: string
    createdAt: string
    actorName: string
    actorId: string
  }
  shipmentType: string
  isPriority: boolean
  pickupBoosterAmount: number
  executionPlatform: string
}

dayjs.extend(dayjsDuration)

@Component({
  components: {
    PaperPlanIcon,
    ListIcon,
    Button,
    PriorityIcon,
    EyeIcon,
    EyeDisabledIcon
  },
})
class PickupItemCRRPIC extends Vue {
  @Prop({ required: true }) public no!: number
  @Prop({ required: true }) public data!: Pickup

  get date(): string {
    return Utils.formatDateWithIDLocale(
      this.data.history.createdAt,
      'DD-MMM-YYYY',
    )
  }

  get time(): string {
    return Utils.formatTimeZone(
      Utils.formatDateWithIDLocale(
        this.data.history.createdAt,
        'HH:mm Z'
      )
    )
  }

  get duration(): string {
    const duration = dayjs.duration(dayjs().diff(dayjs(this.data.createdAt)))

    const result = []

    //Get Days
    const days = Math.floor(duration.asDays())
    if (days) {
      result.push(`${days}d`)
    }

    //Get Hours
    const hours = duration.hours()
    if (hours) {
      result.push(`${hours}h`)
    }

    //Get Minutes
    const minutes = duration.minutes()
    result.push(`${minutes}m`)

    return result.join(', ')
  }

  get hasCourierPickupDetail(): boolean {
    return !!this.data.courierPickupDetail
  }

  get courier(): string {
    if (this.hasCourierPickupDetail) {
      const courierPickupDetail = this.data.courierPickupDetail
      return `${courierPickupDetail?.courierTypeValid}-${courierPickupDetail?.courierName} (${courierPickupDetail?.phoneNumber || '********'})`
    }

    return this.data.history.actorName
  }

  get overSLA(): boolean {
    return dayjs().diff(dayjs(this.data.createdAt), 'hours') >= 48
  }

  get isBosspack(): boolean {
    return this.data.productType === 'BOSSPACK'
  }

  get canBeCancelled(): boolean {
    return (
      this.data.shipmentId.substr(0, 2) === 'AG' ||
      this.data.shipmentId.substr(0, 3) === 'ARA' ||
      this.data.shipmentId.substr(0, 3) === 'GAG' ||
      this.data.shipmentId.substr(0, 4) === 'GARA' ||
      this.data.shipmentId.substr(0, 2) === 'C1' ||
      this.data.shipmentId.substr(0, 2) === 'CP'
    )
  }

  get pickupBoosterAmount(): string {
    return this.data.pickupBoosterAmount
      ? `Rp${Utils.currencyDigit(this.data.pickupBoosterAmount)}`
      : ''
  }

  async showCustPhone(event: any) {
    event.stopPropagation();

    const resp = await PickupController.adminContactShow({
      field: 'pickup_phone',
      resource: 'shipment',
      resourceId: this.data.shipmentId,
      source: 'pickup_crrpic'
    })

    this.data.pickup.phoneNumber = resp.value;
  }

  hideCustPhone(event: any) {
    event.stopPropagation();
    this.data.pickup.phoneNumber = '';
  }

  async showCourierPhone(event: any) {
    event.stopPropagation();

    const resp = await PickupController.adminContactShow({
      field: 'courier_phone',
      resource: 'courier',
      resourceId: this.data.courierPickupDetail.courierId,
      source: 'pickup_crrpic'
    })

    this.data.courierPickupDetail.phoneNumber = resp.value;
  }

  hideCourierPhone(event: any) {
    event.stopPropagation();
    this.data.courierPickupDetail.phoneNumber = '';
  }


  async showCustAddress(event: any) {
    event.stopPropagation();

    const resp = await PickupController.adminContactShow({
      field: 'pickup_address',
      resource: 'shipment',
      resourceId: this.data.shipmentId,
      source: 'pickup_crrpic'
    })

    this.data.pickup.address = resp.value;
  }

  hideCustAddress(event: any) {
    event.stopPropagation();
    this.data.pickup.address = '';
  }
}

export default PickupItemCRRPIC;
